import { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
//styles
import classes from "./helpCenter.module.scss";
//icons
import { ReactComponent as AddIcon } from "@/assets/images/icons/Maintainers/plus-solid.svg";
//Components
import Head from "@/components/Content/Head";
import CategoryForm from "./CategoryForm";
import CategoryAccordion from "./CategoryAccordion";
import Fetching from "@/components/Fetching/Fetching";
//services
import api from "@/services/api.service";
import { FETCH_HELP_CENTER_SUCCESS } from "@/redux/types/help_center.types";

const HelpCenter = () => {
	const dispatch = useDispatch();
	const [page] = useState(1);
	const [addForm, setAddForm] = useState(false);
	const { questions, loading } = useSelector((state) => state.help_center);

	const handleAddModal = () => {
		setAddForm(true);
	};
	const handleClose = () => {
		setAddForm(false);
	};

	useEffect(() => {
		const params = {
			page,
		};
		api.get("/landing/base_help", params).then((response) => {
			dispatch({
				type: FETCH_HELP_CENTER_SUCCESS,
				payload: {
					questions: response.questions.data,
				},
			});
		});
	}, [dispatch, page]);
	return (
		<>
			<Head title="Centro de Ayuda" />
			<Row className={`${classes.main_content}`}>
				<Col md={12} className={`${classes.body}`}>
					<div>
						<button onClick={handleAddModal}>
							{" "}
							Agregar categoria <AddIcon className={`${classes.add_icon}`} />
						</button>
					</div>

					<Col className={`${classes.content}`}>
						{questions && questions.map((item, index) => <CategoryAccordion key={index} item={item} id={index + 1} />)}
						{loading && <Fetching topMargin={"0px"} />}
					</Col>

					<CategoryForm show={addForm} setAddForm={setAddForm} handleClose={handleClose} classes={classes} />
				</Col>
			</Row>
		</>
	);
};

export default HelpCenter;
